import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { IEnvironment } from '@models';

@Component({
    templateUrl: './environment-robots.modal.html',
    styleUrls: ['./environment-robots.modal.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnvironmentRobotsModalComponent
    extends UiModalComponent<IEnvironment> {
}
